export const NEIGHBORHOODS = [
  'Santa Monica',
  'Venice',
  'Brentwood',
  'Westwood',
  'Bel Air',
  'Century City',
  'Beverly Hills',
  'Culver City',
  'Mar Vista',
  'Marina del Rey',
  'Playa del Rey',
  'Playa Vista',
  'West Hollywood',
  'Los Feliz',
  'Silver Lake',
  'Palms',
  'Pacific Palisades',
  'Sawtelle',
  'Malibu',
];
